<template>
  <BuildingSectionCard
    title="Building amenities"
    :subtitle="items.length ? `${items.length} of ${buildingAmenityKeys.length} selected` : undefined"
    :form="AmenitiesForm"
    :has-info="items.length > 0"
    :placeholder="{
      title: 'No building amenities yet',
      subtitle: 'Elevator, gym, pool, gated entry — set once here, every unit lists them.',
      buttonText: 'Add amenities',
    }"
  >
    <PropertyCheckList :items="items" />
  </BuildingSectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { AmenitiesForm, BuildingDto, buildingAmenityKeys } from '@tallo/investor/property';
import { CheckListItem, PropertyCheckList, amenityNamesMap } from '@tallo/property';

import BuildingSectionCard from '../../../components/building-section-card.vue';

/** What the building offers, as a list of what is there; what it does not offer is left out rather than crossed off */
const props = defineProps<{ building: BuildingDto }>();

const items = computed<CheckListItem[]>(() =>
  buildingAmenityKeys
    .filter((key) => props.building.amenities?.[key])
    .map((key) => ({ label: amenityNamesMap[key], value: true }))
    .sort((a, b) => a.label.localeCompare(b.label)),
);
</script>
